import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import {
  branch,
  compose,
  renderComponent,
  setPropTypes,
  defaultProps,
  mapProps
} from 'recompose'

const RedirectComponent = ({ to }) => (
  <Redirect
    push
    to={to}
  />
)

const withDefaultProps = defaultProps({
  to: '/',
  redirect: false
})

const withPropTypes = setPropTypes({
  to: PropTypes.string.isRequired,
  redirect: PropTypes.bool,
})

const withRedirect = branch(
  ({ redirect }) => redirect,
  renderComponent(RedirectComponent)
)

const withoutRedirectState = mapProps(({ redirect, ...rest }) => ({ ...rest }))

export default compose(
  withDefaultProps,
  withPropTypes,
  withRedirect,
  withoutRedirectState
)
